import { createContext, useState } from 'react';
import api from 'services/api';
import moment from 'moment';

const filter = {
  like: '',
  id: '',
  status: ['PENDENTE'],
  situacao: [],
  tipo: [],
  despesa: '',
  dtemissao: {
    i: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    f: null,
  },
  documento: '',
  entidade: [],
  vldocto: '',
  filial: [],
};

export const DespesasContext = createContext();

export const DespesasProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [despesas, setDespesas] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter,
    page: 0,
    size: 10,
  });

  const getDespesas = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: despesas?.filter,
        page: despesas?.page,
        size: despesas?.size,
        order: despesas?.order,
        ...payload,
      });
      setDespesas((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <DespesasContext.Provider
      value={{
        getLoading,
        getDespesas,
        despesas,
      }}
    >
      {children}
    </DespesasContext.Provider>
  );
};
